// Models
import { EntityType } from '@/models/logs.model';
import { IPaginationDTO } from '@/models/pagination.model';

// Components
import { EmptyDataThumbnail, Pagination, Spinner } from '@/ui';
import { LogCard } from '../../components';
import { StyledCard, StyledContainer, StyledPagination } from './LogsListContainerStyles';

// Helpers
import { GetActionLogsDTO } from '../../dtos';
import { useGetActionLogs } from '../../hooks';

// Store
import { useAppDispatch } from '@/store';
import { getActionLogs } from '../../feature';

type TLogsListContainerProps = {
  id: string;
  entityType: EntityType;
};

const LogsListContainer = ({ id, entityType }: TLogsListContainerProps) => {
  const { isLoading, actionLogs, pagination } = useGetActionLogs(id, entityType);
  const dispatch = useAppDispatch();

  const handlePageChange = (value: IPaginationDTO) => {
    const dto = new GetActionLogsDTO({ id, entityType, ...value });
    dispatch(getActionLogs(dto));
  };

  return (
    <Spinner spinning={isLoading}>
      <StyledContainer>
        {actionLogs?.length === 0 && <EmptyDataThumbnail />}
        {actionLogs?.map((log) => (
          <StyledCard key={log.SK}>
            <LogCard log={log} entityType={entityType} />
          </StyledCard>
        ))}
        {!!actionLogs?.length && (
          <StyledPagination>
            <Pagination cursor={pagination ?? {}} loading={isLoading} onChange={handlePageChange} />
          </StyledPagination>
        )}
      </StyledContainer>
    </Spinner>
  );
};

export default LogsListContainer;
